import script from "./CompareChartLactate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareChartLactate.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__